<script>
import Layout from '@layouts/main.vue'
import TipButtons from '@components/tip-buttons.vue'
import CurrencyInput from '@components/currency-input.vue'

import { validateCurrency } from '@utils/validation'
import { mapGetters, mapActions } from 'vuex'
import PageHeader from '@components/page-header.vue'

export default {
  page: {
    title: 'Tip',
    meta: [{ name: 'description', content: 'The Tip page.' }],
  },
  components: { PageHeader, TipButtons, Layout, CurrencyInput },
  data: () => ({
    tipValid: true,
  }),
  computed: {
    ...mapGetters({
      content: 'contentful/getContent',
      total: 'payment/getTotal',
      tip: 'payment/getTip',
    }),
  },
  beforeMount() {
    this.checkForData()
  },
  methods: {
    ...mapActions({
      checkForData: 'payment/checkForData',
      setTipAmount: 'payment/setTip',
    }),
    handleSelect(tip) {
      this.$refs.input.handleClear()
      this.setTipAmount({ tip })
    },
    handleInput(tip) {
      this.$refs.buttons.handleClear()
      this.tipValid = !tip || validateCurrency(tip)
      if (this.tipValid || !tip) {
        this.setTipAmount({ tip })
      }
    },
    handleNoneLink() {
      this.setTipAmount({ tip: null })
      this.$router.push('/details').catch(() => {})
    },
    handleSubmit() {
      if (this.tipValid) {
        this.$router.push('/details').catch(() => {})
      }
    },
  },
}
</script>

<template>
  <Layout screen="tip">
    <PageHeader :page="1" title="Add Tip?" />
    <div class="content">
      <div>
        <div ref="tipButtons">
          <TipButtons ref="buttons" :total="total" @select="handleSelect" />
        </div>
        <h4
          ref="description"
          class="pre-line"
          :class="$style.description"
          v-text="`Or whatever you feel`"
        />
        <div ref="inputContainer">
          <CurrencyInput
            ref="input"
            placeholder="Enter tip amount"
            @input="handleInput"
            @submit="handleSubmit"
          />
          <p
            v-if="!tipValid"
            class="validation"
            v-text="content.tipValidation"
          />
        </div>
      </div>
      <div class="footer">
        <BaseButton
          :disabled="!tip || !tipValid"
          @click="handleSubmit"
          v-text="`Confirm Tip`"
        />
        <a
          ref="noneLink"
          :class="$style.noneLink"
          @click="handleNoneLink"
          v-text="`I don't want to add a tip`"
        />
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 65px);
  padding: 0 2.5rem;
  text-align: center;
  > * {
    width: 100%;
  }
}

.presets {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.noneLink {
  @extend %font-secondary;
  color: var(--color-text-secondary);
  font-size: 0.75rem;
  text-decoration: underline;
  margin: 20px 0;
}

.description {
  text-transform: uppercase;
  padding-top: 1rem;
}
</style>
